import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';

const VerificationTest = () => {
  const navigate = useNavigate();
  const [step, setStep] = useState(1);

  const simulateRegistration = () => {
    // Simulate the registration response
    const mockUser = {
      id: 6,
      first_name: "Shailesh",
      last_name: "Khandar",
      email: "khandarshailesh111+1@gmail.com",
      phone_no: "9574233002"
    };

    // Store in session storage like the real flow
    sessionStorage.setItem('pendingUser', JSON.stringify(mockUser));
    sessionStorage.setItem('verificationEmail', mockUser.email);
    sessionStorage.setItem('verificationPhone', mockUser.phone_no);

    setStep(2);
  };

  const goToEmailVerification = () => {
    navigate('/verify-email');
  };

  const goToMobileVerification = () => {
    navigate('/verify-mobile');
  };

  const clearSessionData = () => {
    sessionStorage.removeItem('pendingUser');
    sessionStorage.removeItem('verificationEmail');
    sessionStorage.removeItem('verificationPhone');
    sessionStorage.removeItem('emailOtpSentTime');
    sessionStorage.removeItem('mobileOtpSentTime');
    setStep(1);
  };

  return (
    <div className="p-8 max-w-2xl mx-auto">
      <h1 className="text-2xl font-bold mb-6">Verification Flow Test</h1>
      
      <div className="space-y-6">
        {/* Step 1: Registration */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="card card-body"
        >
          <h2 className="text-xl font-semibold mb-4">Step 1: Registration</h2>
          <p className="text-gray-600 mb-4">
            Simulate the registration process that returns the user data.
          </p>
          <button
            onClick={simulateRegistration}
            className="btn btn-primary"
            disabled={step > 1}
          >
            {step > 1 ? '✓ Registration Completed' : 'Simulate Registration'}
          </button>
        </motion.div>

        {/* Step 2: Email Verification */}
        {step >= 2 && (
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="card card-body"
          >
            <h2 className="text-xl font-semibold mb-4">Step 2: Email Verification</h2>
            <p className="text-gray-600 mb-4">
              Verify email address with OTP.
            </p>
            <button
              onClick={goToEmailVerification}
              className="btn btn-primary"
            >
              Go to Email Verification
            </button>
          </motion.div>
        )}

        {/* Step 3: Mobile Verification */}
        {step >= 2 && (
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="card card-body"
          >
            <h2 className="text-xl font-semibold mb-4">Step 3: Mobile Verification</h2>
            <p className="text-gray-600 mb-4">
              Verify mobile number with OTP (after email verification).
            </p>
            <button
              onClick={goToMobileVerification}
              className="btn btn-primary"
            >
              Go to Mobile Verification
            </button>
          </motion.div>
        )}

        {/* Session Data */}
        <div className="card card-body">
          <h3 className="text-lg font-semibold mb-3">Current Session Data</h3>
          <div className="space-y-2 text-sm">
            <div>
              <strong>Pending User:</strong> {sessionStorage.getItem('pendingUser') || 'None'}
            </div>
            <div>
              <strong>Email:</strong> {sessionStorage.getItem('verificationEmail') || 'None'}
            </div>
            <div>
              <strong>Phone:</strong> {sessionStorage.getItem('verificationPhone') || 'None'}
            </div>
          </div>
          <button
            onClick={clearSessionData}
            className="btn btn-secondary mt-3"
          >
            Clear Session Data
          </button>
        </div>

        {/* Quick Navigation */}
        <div className="card card-body">
          <h3 className="text-lg font-semibold mb-3">Quick Navigation</h3>
          <div className="space-x-3">
            <button
              onClick={() => navigate('/register')}
              className="btn btn-outline"
            >
              Register Page
            </button>
            <button
              onClick={() => navigate('/login')}
              className="btn btn-outline"
            >
              Login Page
            </button>
            <button
              onClick={() => navigate('/dashboard')}
              className="btn btn-outline"
            >
              Dashboard
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VerificationTest;